var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    { attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40" } },
    [
      _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
        _c("rect", {
          attrs: { fill: "#EE4848", width: "40", height: "40", rx: "4" }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M27.0049107 11C28.1067681 11 29 11.8926228 29 12.9950893v14.0098214C29 28.1067681 28.1073772 29 27.0049107 29H12.9950893C11.8932319 29 11 28.1073772 11 27.0049107V12.9950893C11 11.8932319 11.8926228 11 12.9950893 11h14.0098214zm-6.9948436 12.526393c-.4295323 0-.7885891.1397835-1.0771812.4193548-.288592.2795713-.4328859.635384-.4328859 1.0674487 0 .4320647.1442939.7878774.4328859 1.0674487.2885921.2795713.6476489.4193548 1.0771812.4193548.4295324 0 .7852335-.1397835 1.0671141-.4193548.2818806-.2795713.4228188-.635384.4228188-1.0674487 0-.4320647-.1409382-.7878774-.4228188-1.0674487-.2818806-.2795713-.6375817-.4193548-1.0671141-.4193548zM21.1778523 13.5h-2.3355704l.0604027 2.1730205.3221476 6.5h1.5503356l.3221476-6.5L21.1778523 13.5z",
            fill: "#FFF"
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }